import { A7PageSizeMatcher } from '@ark7/layout';
import { Component } from '@angular/core';

@Component({
    selector: 'app-andes-secondary-market-trading-agreement',
    templateUrl: './andes-secondary-market-trading-agreement.component.html',
    styleUrls: ['./andes-secondary-market-trading-agreement.component.scss'],
    standalone: false
})
export class AndesSecondaryMarketTradingAgreementComponent {
  @A7PageSizeMatcher('SM-') sm;
}
